/**
 * Textes de l'écran « Demandes » : les demandes d'ouverture envoyées depuis
 * artosera.com (composeur, page options, formulaire de contact). Fichier à
 * part, fusionné dans le namespace `console` (D15). Voix 2.2 : phrases
 * courtes, un verbe sur chaque bouton.
 */

export const frDemandesOuverture = {
  demandesOuverture: {
    titre: 'Demandes d’ouverture',
    texte:
      'Les galeries qui veulent ouvrir leur espace Artosera. Qualifiez la demande, puis créez le dossier d’ouverture.',
    chargement: 'Chargement des demandes…',
    erreurChargement: 'Impossible de lire les demandes d’ouverture.',
    vide: 'Aucune demande ne correspond à ces filtres.',
    videTout: 'Aucune demande d’ouverture pour le moment.',
    introuvable: 'Cette demande n’existe pas ou a été purgée.',
    retour: 'Toutes les demandes',
    etat: {
      nouvelle: 'Nouvelle',
      qualifiee: 'Qualifiée',
      offre_envoyee: 'Offre envoyée',
      convertie: 'Convertie',
      perdue: 'Perdue',
    },
    source: {
      composeur: 'Composeur',
      contact: 'Formulaire de contact',
      console: 'Console',
    },
    filtres: {
      etats: 'Filtrer par état',
      toutes: 'Toutes',
      recherche: 'Rechercher',
      recherchePlaceholder: 'Numéro, nom, e-mail ou galerie',
      source: 'Source',
      toutesSources: 'Toutes les sources',
      responsable: 'Responsable',
      tous: 'Tous',
      moi: 'Moi',
      personne: 'Personne',
    },
    colonnes: {
      numero: 'Numéro',
      galerie: 'Galerie',
      contact: 'Contact',
      source: 'Source',
      palier: 'Palier',
      modules: 'Modules',
      responsable: 'Responsable',
      anciennete: 'Ancienneté',
    },
    sansPalier: 'Non précisé',
    sansResponsable: 'Personne',
    sansNom: 'Galerie sans nom',
    anciennete: {
      aujourdhui: 'Aujourd’hui',
      jours: '{{count}} j',
    },
    pagination: {
      precedente: 'Précédente',
      suivante: 'Suivante',
      page: 'Page {{page}} sur {{total}}',
    },
    fiche: {
      recue: 'Reçue le {{date}}',
      responsable: 'Responsable',
      sections: {
        contact: 'Contact',
        galerie: 'Galerie',
        selection: 'Sélection',
        message: 'Message',
        notes: 'Notes',
        historique: 'Historique',
        envois: 'Courriels envoyés',
        consentement: 'Consentement',
      },
      contact: {
        nom: 'Nom',
        email: 'E-mail',
        telephone: 'Téléphone',
        fonction: 'Fonction',
        langue: 'Langue',
      },
      langue: { fr: 'Français', en: 'Anglais' },
      galerie: {
        nom: 'Nom',
        ville: 'Ville',
        pays: 'Pays',
        siteWeb: 'Site web',
      },
      nonRenseigne: 'Non renseigné',
      selection: {
        palier: 'Palier',
        modules: 'Modules',
        addons: 'Add-ons',
        services: 'Services',
        accompagnement: 'Accompagnement',
        aucun: 'Aucun',
        ignores_one: '{{count}} identifiant inconnu écarté.',
        ignores_other: '{{count}} identifiants inconnus écartés.',
      },
      choix: {
        indispensable: 'Indispensable',
        interessant: 'Intéressant',
        'plus-tard': 'Plus tard',
        'pas-pour-nous': 'Pas pour nous',
      },
      accompagnement: {
        choix: { oui: 'Oui', 'a-discuter': 'À discuter', non: 'Non' },
        prestation: {
          'mise-en-place': 'Mise en place',
          'reprise-donnees': 'Reprise des données',
          'reprise-complexe': 'Reprise complexe',
          formation: 'Formation',
          assistance: 'Assistance',
          'evolutions-sur-mesure': 'Évolutions sur mesure',
        },
      },
      messageVide: 'Aucun message.',
      notesVide: 'Aucune note.',
      noteParLe: '{{par}}, le {{date}}',
      historiqueLigne: '{{par}}, le {{date}}',
      envois: {
        accuse: 'Accusé de réception',
        alerte: 'Alerte à l’équipe',
        enAttente: 'En attente',
        envoyeLe: 'Envoyé le {{date}}',
      },
      consentement: 'Notice {{version}}, acceptée le {{date}}',
      dossier: {
        titre: 'Dossier d’ouverture',
        lien: 'Ouvrir le dossier {{numero}}',
      },
      motifPerte: 'Motif de la perte',
      gestes: {
        titre: 'Gestes',
        lectureSeule: 'Votre rôle ne permet que de lire cette demande.',
        aucun: 'Aucun geste possible dans cet état.',
        qualifier: 'Qualifier',
        creerDossier: 'Créer le dossier',
        creerDossierEnCours: 'Création du dossier…',
        perdre: 'Marquer perdue',
      },
      responsableChamp: 'Responsable de la demande',
      responsableAide: 'Vous pouvez vous attribuer la demande ou la laisser sans responsable.',
      responsableFerme: 'Une demande close n’a plus de responsable à choisir.',
      noteChamp: 'Ajouter une note',
      noteAjouter: 'Ajouter la note',
      notePosee: 'Note ajoutée.',
      responsableMaj: 'Responsable mis à jour.',
      qualifiee: 'Demande qualifiée.',
      perdue: {
        titre: 'Marquer la demande perdue',
        texte: 'Dites pourquoi cette demande n’aboutit pas. Le motif reste dans l’historique.',
        motif: 'Motif (3 à 1000 caractères)',
        motifErreur: 'Le motif doit faire au moins 3 caractères.',
        confirmer: 'Marquer perdue',
        annuler: 'Annuler',
        fermer: 'Fermer la fenêtre',
        succes: 'Demande marquée perdue.',
      },
    },
    recharger: 'Recharger la demande',
    erreurs: {
      revision_demande_perimee:
        'La demande a changé entre-temps. Rechargez-la pour voir la dernière version, puis recommencez.',
      demande_convertie: 'Cette demande est déjà convertie en dossier d’ouverture.',
      demande_convertie_lien: 'Ouvrir le dossier',
      etat_incompatible:
        'Ce geste n’est pas possible dans l’état actuel de la demande. Rechargez-la.',
      droits: 'Votre rôle ne permet pas ce geste.',
      reseau: 'Impossible de joindre le serveur. Réessayez.',
      generique: 'Le geste a échoué. Réessayez.',
    },
  },
};

export const enDemandesOuverture = {
  demandesOuverture: {
    titre: 'Opening requests',
    texte:
      'Galleries that want to open their Artosera space. Qualify the request, then create the onboarding file.',
    chargement: 'Loading requests…',
    erreurChargement: 'Could not read the opening requests.',
    vide: 'No request matches these filters.',
    videTout: 'No opening request yet.',
    introuvable: 'This request does not exist or has been purged.',
    retour: 'All requests',
    etat: {
      nouvelle: 'New',
      qualifiee: 'Qualified',
      offre_envoyee: 'Offer sent',
      convertie: 'Converted',
      perdue: 'Lost',
    },
    source: {
      composeur: 'Composer',
      contact: 'Contact form',
      console: 'Console',
    },
    filtres: {
      etats: 'Filter by state',
      toutes: 'All',
      recherche: 'Search',
      recherchePlaceholder: 'Number, name, email or gallery',
      source: 'Source',
      toutesSources: 'All sources',
      responsable: 'Owner',
      tous: 'Everyone',
      moi: 'Me',
      personne: 'Nobody',
    },
    colonnes: {
      numero: 'Number',
      galerie: 'Gallery',
      contact: 'Contact',
      source: 'Source',
      palier: 'Tier',
      modules: 'Modules',
      responsable: 'Owner',
      anciennete: 'Age',
    },
    sansPalier: 'Not specified',
    sansResponsable: 'Nobody',
    sansNom: 'Unnamed gallery',
    anciennete: {
      aujourdhui: 'Today',
      jours: '{{count}} d',
    },
    pagination: {
      precedente: 'Previous',
      suivante: 'Next',
      page: 'Page {{page}} of {{total}}',
    },
    fiche: {
      recue: 'Received on {{date}}',
      responsable: 'Owner',
      sections: {
        contact: 'Contact',
        galerie: 'Gallery',
        selection: 'Selection',
        message: 'Message',
        notes: 'Notes',
        historique: 'History',
        envois: 'Emails sent',
        consentement: 'Consent',
      },
      contact: {
        nom: 'Name',
        email: 'Email',
        telephone: 'Phone',
        fonction: 'Role',
        langue: 'Language',
      },
      langue: { fr: 'French', en: 'English' },
      galerie: {
        nom: 'Name',
        ville: 'City',
        pays: 'Country',
        siteWeb: 'Website',
      },
      nonRenseigne: 'Not given',
      selection: {
        palier: 'Tier',
        modules: 'Modules',
        addons: 'Add-ons',
        services: 'Services',
        accompagnement: 'Support',
        aucun: 'None',
        ignores_one: '{{count}} unknown identifier discarded.',
        ignores_other: '{{count}} unknown identifiers discarded.',
      },
      choix: {
        indispensable: 'Essential',
        interessant: 'Interesting',
        'plus-tard': 'Later',
        'pas-pour-nous': 'Not for us',
      },
      accompagnement: {
        choix: { oui: 'Yes', 'a-discuter': 'To discuss', non: 'No' },
        prestation: {
          'mise-en-place': 'Setup',
          'reprise-donnees': 'Data migration',
          'reprise-complexe': 'Complex migration',
          formation: 'Training',
          assistance: 'Assistance',
          'evolutions-sur-mesure': 'Custom development',
        },
      },
      messageVide: 'No message.',
      notesVide: 'No notes.',
      noteParLe: '{{par}}, on {{date}}',
      historiqueLigne: '{{par}}, on {{date}}',
      envois: {
        accuse: 'Acknowledgement',
        alerte: 'Team alert',
        enAttente: 'Pending',
        envoyeLe: 'Sent on {{date}}',
      },
      consentement: 'Notice {{version}}, accepted on {{date}}',
      dossier: {
        titre: 'Onboarding file',
        lien: 'Open file {{numero}}',
      },
      motifPerte: 'Reason for loss',
      gestes: {
        titre: 'Actions',
        lectureSeule: 'Your role can only read this request.',
        aucun: 'No action is possible in this state.',
        qualifier: 'Qualify',
        creerDossier: 'Create the file',
        creerDossierEnCours: 'Creating the file…',
        perdre: 'Mark as lost',
      },
      responsableChamp: 'Request owner',
      responsableAide: 'You can take the request yourself or leave it without an owner.',
      responsableFerme: 'A closed request no longer has an owner to pick.',
      noteChamp: 'Add a note',
      noteAjouter: 'Add the note',
      notePosee: 'Note added.',
      responsableMaj: 'Owner updated.',
      qualifiee: 'Request qualified.',
      perdue: {
        titre: 'Mark the request as lost',
        texte: 'Say why this request does not go ahead. The reason stays in the history.',
        motif: 'Reason (3 to 1000 characters)',
        motifErreur: 'The reason must be at least 3 characters long.',
        confirmer: 'Mark as lost',
        annuler: 'Cancel',
        fermer: 'Close the window',
        succes: 'Request marked as lost.',
      },
    },
    recharger: 'Reload the request',
    erreurs: {
      revision_demande_perimee:
        'The request changed in the meantime. Reload it to see the latest version, then try again.',
      demande_convertie: 'This request has already been converted into an onboarding file.',
      demande_convertie_lien: 'Open the file',
      etat_incompatible: 'This action is not possible in the request’s current state. Reload it.',
      droits: 'Your role does not allow this action.',
      reseau: 'Could not reach the server. Try again.',
      generique: 'The action failed. Try again.',
    },
  },
};
